module.exports = __webpack_public_path__ + "ipetbooking-landing/img/illustration04.dd6808ff.svg";